import { Td, Th, Tr } from '@chakra-ui/react';
import { useAuth, usePagination } from 'core';
import {
  AfeLink,
  CurrencyLabel,
  InvoiceLink,
  SearchTableButtonGroup,
  VendorLink,
} from 'features/components';
import { useState } from 'react';
import {
  useFetchInvoicesPageQuery,
  useFetchInvoiceTransactionsQuery,
} from '../../api';
import { InvoicedVsCommitmentBar } from '../components/FinancialBars';
import { AppTable } from '../table';
import {
  InvoiceFormWorkflowDrawer,
  InvoiceFormWorkflowDrawerProps,
  InvoiceWorkflowStage,
} from './InvoiceFormWorkflowDrawer';

export interface InvoiceSearchPageProps {}

export const InvoiceSearchPage = (props: InvoiceSearchPageProps) => {
  // Fetches
  const auth = useAuth();
  const [page, setPagination] = usePagination();

  const { data: results, isLoading } = useFetchInvoicesPageQuery(
    {
      ...page,
      clientId: auth?.user?.clientId ?? "0",
    },
    {
      skip: !auth,
    }
  );

  // State
  const [invoiceDrawer, setInvoiceDrawer] =
    useState<Omit<InvoiceFormWorkflowDrawerProps, 'onClose'>>();

  let body = (
    <>
      <Tr>
        <Td>Loading...</Td>
      </Tr>
    </>
  );

  if (!isLoading) {
    body = (
      <>
        {results?.items.map((inv, i) => (
          <Tr key={i}>
            <Td>
              <InvoiceLink i={inv} />
            </Td>
            <Td>
              <VendorLink v={inv.vendor} />
            </Td>
            <Td>
              <AfeLink afe={inv.afe} />
            </Td>

            {/* <Td>
              <InvoicedVsCommitmentBar
                invoice={inv?.total}
                pendingInvoice={inv?.pending}
                commitment={inv?.totalCommitment}
              />
            </Td> */}
            <Td>
              <CurrencyLabel value={inv.total} />
            </Td>
          </Tr>
        ))}
      </>
    );
  }

  return (
    <>
      {invoiceDrawer && (
        <InvoiceFormWorkflowDrawer
          {...invoiceDrawer}
          onClose={() => setInvoiceDrawer(undefined)}
        />
      )}
      <AppTable
        title="Search Invoices"
        buttonGroup={(props) => (
          <SearchTableButtonGroup
            {...props}
            entityName="Invoice"
            onNewEntity={() =>
              setInvoiceDrawer({
                initialStage: InvoiceWorkflowStage.invoice,
                isOpen: true,
                invoice: undefined,
              })
            }
          />
        )}
        header={
          <>
            <Tr>
              <Th>Invoice</Th>
              <Th>Vendor</Th>
              <Th>Project</Th>
              <Th>Amount</Th>
              {/* <Th>Reference</Th> */}
              {/* <Th>Invoiced</Th>
            <Th>Received</Th>
            <Th>Due</Th> */}
              {/* <Th>Invoiced</Th> */}
              {/* <Th>Paid</Th> */}
              {/* <Th>Pending</Th> */}
              {/* <Th>Vs. Commitments</Th> */}
            </Tr>
          </>
        }
        body={body}
        pagination={{
          ...page,
          pageCount: results ? Number(results.pageCount) : 1,
          itemCount: results ? Number(results.itemCount) : 0,
        }}
        onPaginationChange={(settings) => setPagination(settings)}
      />
    </>
  );
};
